import { LabelContainer, Submit } from "../RegisterPage/StyledRegister";
import styled from "styled-components";

export const LoginContainer = styled(LabelContainer)`
  margin-bottom: 30px;
`;

export const HomeBtn = styled(Submit)``;

export const RegisterBtn = styled(Submit)`
  background: rgba(245, 235, 255, 0.3);
  margin-top: 10px;
`;
